import { Button } from '@mm/components';
import { useSignalConfigurationCRUDActions } from '@mm/state/actions/SignalConfigurationCRUDActions';
import { Configuration } from '@mm/state/model/SignalModel';
import {
  activeChatbotIdSelector,
  activeFacebookPageIdSelector,
} from '@mm/state/selectors/viewSelectors';
import { StoreState } from '@mm/state/store-interfaces';
import { Switch } from 'antd';
import classNames from 'classnames';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { BotBuilderRoutes } from '../../../../../../../../routes/bot-builder-routes';
import styles from './KlaviyoIntegrations.module.css';

type Props = {
  controlsDisabled: boolean;
};

export const KlaviyoEventTriggersSetup = ({ controlsDisabled }: Props) => {
  const configuration = useSelector(
    (state: StoreState) => state.signalConfiguration.configuration,
  );

  const activeFbPageId = useSelector(activeFacebookPageIdSelector);

  const chatbotId = useSelector(activeChatbotIdSelector);
  const configurationId = (configuration as Configuration)?.id;
  const { fetch: fetchConfiguration, update: updateConfiguration } =
    useSignalConfigurationCRUDActions();

  useEffect(() => {
    if (activeFbPageId) {
      fetchConfiguration(activeFbPageId);
    }
  }, [activeFbPageId]);

  const isSignalOn = configuration?.integrations.includes('klaviyo');

  const history = useHistory();

  const redirectTosignal = () => {
    history.push(BotBuilderRoutes.signal.getLink({ chatbotId }));
  };

  return (
    <div
      className={classNames(styles.box, {
        [styles.boxDisabled]: controlsDisabled,
      })}
    >
      <div className={classNames(styles.boxWithHelp, styles.startAlligned)}>
        <div className={styles.boxContent}>
          <div
            className={classNames(
              styles.heading,
              styles.headingWithSwitch,
              styles.eventTriggersHeading,
            )}
          >
            <div>
              <Switch
                checked={isSignalOn}
                size="small"
                className={styles.switch}
                onChange={ok => {
                  if (configurationId) {
                    const existingIntegrationsWithoutKlaviyo =
                      configuration?.integrations.filter(
                        integration => integration !== 'klaviyo',
                      ) || [];
                    const updatedIntegrations = ok
                      ? [...existingIntegrationsWithoutKlaviyo, 'klaviyo']
                      : existingIntegrationsWithoutKlaviyo;
                    updateConfiguration({
                      id: configurationId,
                      integrations: updatedIntegrations,
                    });
                  }
                }}
              />
            </div>
            <div>
              <b>Signal</b> Known visitor monitor
            </div>
          </div>
        </div>
      </div>
      <Button
        color="blue"
        css={{ container: styles.heading }}
        onClick={redirectTosignal}
      >
        {isSignalOn ? 'Go to Signal' : 'Set up Signal'}
      </Button>
    </div>
  );
};
